export default __webpack_public_path__ + "static/media/tab-replied.740e4602.svg";